import React, { Component } from 'react';
import MyInput from 'components/controls/MyInput';
import _validator from 'modules/validator';
import BoxInput from 'components/controls/BoxInput';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService';
import { DatePicker, Icon } from 'antd';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
import moment from 'moment';
import NavigationTab from './NavigationTab_new_one';
//import Payments from '../../components/controls/Payments';
import Payments from '../../components/controls/PaymentsIOBCCAvenue';

import { Checkbox } from 'antd';
import { TRANSACTIONNUMBERCOUNT } from '../../constants/constants.js';
// Stage 3.5 (Enterprise Candidate Registration Wizard Modernization): the Stage 3.2 shared Card
// replaces this page's `.candidateform-cover` section in both render branches. The embedded
// <Payments> (PaymentsIOBCCAvenue.jsx) component itself is not edited.
import Card from 'components/enterprise/Card';
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

// Stage 3.9 (Task 2/5): validation messages are set via setState with a plain string, so they use the
// plain resolveText() helper — see NewLogin.jsx/ForgotPassword_new.jsx's identical comment for why.
function tr(key) {
    return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class SubmitForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            Challan_Transaction_Id: '',
            Challan_Payment_Date: "",
            loading: false,
            transactionIDError: '',
            isAck: false,
            dobError: '',
            // Sprint 2.6.2 (Candidate Experience Modernization): the post-submit navigation/redirect below
            // is deliberately left commented out (unknown original reason, touches the real payment-
            // completion flow) — this makes the success feedback that DOES fire more prominent by keeping
            // it visible on-screen, rather than only a transient 2-5s toast.
            submissionSuccessful: false
        };
    }

    

    componentDidMount() {
        this.GetStudentReservationData();
    }

    GetStudentReservationData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let categoryData = await _StudentService.getStudentReservationData();

                    this.setState({
                        ...this.state,
                        data: categoryData.data,
                        loading: false
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    submitFormData = async () => {
        try {

            if (this.validate()) {
                return;
            }

            this.setState({
                loading: true
            }, async () => {
                try {
                    let body = { Challan_Transaction_Id: this.state.Challan_Transaction_Id.trim(), Challan_Payment_Date: this.state.Challan_Payment_Date, Is_Submitted: true };
                    //console.log(body);

                    const response = await _StudentService.submitFormData(body);
                    //console.log(response);
                    if (response.data.IsSuccess) {
                        this.setState({
                            loading: false,
                            submissionSuccessful: true
                        }, () => {
                            _notification.showMessage('success', tr('submitForm.formSubmittedSuccess'));
                            //this.onTabOrderChange();
                            //this.props.history.push({pathname: routes.registrationComplete.basePath, state: { applicationID: response.data.ApplicationId }})
                        })
                    }
                    else {
                        this.setState({
                            loading: false
                        }, () => {
                            _notification.showMessage('error', response.data.message);
                        })
                    }
                } catch (e) {
                    // TODO
                    console.log('Error: ', e);
                }
            });

        } catch (e) { }
    }

    validate = () => {
        this.setState({
            transactionIDError: '',
            dobError:''
        });

        let hasError = false;

        // Sprint 2.6.2 (Candidate Experience Modernization): dropped the duplicate toast for each of these
        // two checks — the inline `transactionIDError`/`dobError` labels right below each field already
        // surface the same message, matching how every other field error in the wizard is signaled.
        if (!this.state.Challan_Transaction_Id) {
            this.setState({ transactionIDError: tr('submitForm.invalidTransactionId') });
            hasError = true
        }

        let count = TRANSACTIONNUMBERCOUNT;

        if (this.state.Challan_Transaction_Id !== "" && this.state.Challan_Transaction_Id.length < count) {
            this.setState({ transactionIDError: tr('submitForm.invalidTransactionNumber') });
            hasError = true
        }


        if (this.state.Challan_Payment_Date === "" || this.state.Challan_Payment_Date === undefined) {
            this.setState({ dobError: tr('submitForm.invalidChallanPaymentDate') });
            hasError = true
        }
        return hasError;
    }

    onTabOrderChange = () => {
        this.props.onTabOrderChange(6);
    }

    // Sprint 2.6.2: a real "Previous" step, distinct from Cancel (which exits to the dashboard). This
    // screen's actual predecessor depends on payment mode (mirrors PreviewCandidateDetails_new.jsx's own
    // branching): offline payment comes from Print Challan (tabID 4); online payment comes directly from
    // Preview (tabID 10), since Challan is skipped entirely for the online path.
    onPrevious = () => {
        this.props.onTabOrderChange(this.props.IsExamPaymentOnline ? 10 : 4);
    }

    onRedirectToHome = () => {
        this.props.onTabOrderChange(-1);
    }
    onBoxInputTextChange = (string) => {
        if (!_validator.isAlphanumeric(string)) {
            return;
        }

        this.setState({
            "Challan_Transaction_Id": string,
        });
    }

    onTextChange = (event) => {
        if (event.target.name == 'Challan_Transaction_Id' && !_validator.isAlphanumeric(event.target.value))
            return;

        if (event.target.name == 'Challan_Transaction_Id' && event.target.value.length > 20)
            return;

        this.setState({
            [event.target.name]: event.target.value,
        });
    }

    onDateChange = (date, dateString) => {
        this.setState({
            Challan_Payment_Date: date ? date.format("YYYY-MM-DDT00:00:00") : ""
        });
    };

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    onChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
        this.setState({
            isAck:!this.state.isAck
        })
      };
    //const StudentPersonalInfo = () => {
    render() {
        // if (this.state.loading)
        //     return <Spin size="large" />

        if (!this.props.IsExamPaymentOnline) {
            return (
                <>
                    
                    <NavigationTab onTabOrderChange={this.onTabOrderChange} currentStep={4} />
                    {this.state.loading && <LoadingSpinner />}
                    {/* Stage 3.9 (Task 1): mt-4/mb-4 -> mt-3/mb-3 — density trim. */}
                    <div className="ch-make-payment ent-container gl-bxbr  analysisWrap p-4 mt-3">
                        {this.state.submissionSuccessful && (
                            <div className="alert alert-success" role="status">
                                <Icon type="check-circle" className="mr-1" />
                                <div className='displayInGrid'>
                                    <Text k="submitForm.formSubmittedSuccess" />
                                </div>
                            </div>
                        )}
                        <Text k="submitForm.offlineSubmitHeading" tag="h4" className="ch-heading4 mb-3" />
                        <Card>
                            <div className="container-fluid pr-0 pl-0 borderb">
                                <div className="row "> 
                                    <div className="col-sm-12"> 
                                        <div  dangerouslySetInnerHTML={{ __html: localStorage['ChallanPaymentFormSubmitNote'] }}></div>
                                    </div>  
                                </div>
                                
                            </div>

                            <div className="container-fluid pt-3 pr-0 pl-0 challan-form">
                                <div className="row flex-sm-row ">
                                    <div className="col-sm-12">
                                        {/* <MyInput
                                            type="text"
                                            value={this.state.Challan_Transaction_Id ? this.state.Challan_Transaction_Id : ""}
                                            name="Challan_Transaction_Id"
                                            onChange={this.onTextChange}
                                            heading={<div className='displayInGrid'><div>Challan Transaction ID</div><div>चलन व्यवहार आयडी</div></div>}
                                            className="w-100"
                                            wrapClass="wrap"
                                            isRequired={true}
                                            errorState={this.state.transactionIDError}
                                            errorMessage={this.state.transactionIDError}
                                        /> */}
                                         
        
                                        <div>
                                            <div className="wrap form-group">
                                                    <BoxInput
                                                    label={
                                                        <label className="card-holder-name">
                                                            <div className='displayInGrid'>
                                                                <Text k="submitForm.transactionNumberLabel" />
                                                            </div>
                                                            <span className='color-red'>*</span>
                                                        </label>
                                                    }
                                                    boxInputNumberCount={TRANSACTIONNUMBERCOUNT}
                                                    boxInputValue={this.state.Challan_Transaction_Id ? this.state.Challan_Transaction_Id : ""}
                                                    errorState={this.state.transactionIDError}
                                                    errorMessage={this.state.transactionIDError}
                                                    name="Challan_Transaction_Id"
                                                    onChange={this.onBoxInputTextChange}
                                                /> 
                                            </div>
                                        </div>            

                                        <div>
                                            <div className="wrap form-group"> 
                                                <label className="card-holder-name">
                                                    <div className='displayInGrid'>
                                                        <Text k="submitForm.challanPaymentDateLabel" />
                                                    </div>
                                                    <span className='color-red'>*</span>


                                                </label>
                                                <DatePicker 
                                                    onChange={this.onDateChange} format="DD-MMM-YYYY" 
                                                    
                                                    value={this.state.Challan_Payment_Date ?
                                                        moment(this.state.Challan_Payment_Date == '0001-01-01T00:00:00' ? 
                                                        moment().format('YYYY-MM-DD') : 
                                                            this.state.Challan_Payment_Date, 'YYYY-MM-DD') : ""}

                                                    disabledDate={d => !d || d.isAfter(moment()) || d.isSameOrBefore("1900-01-01")}
                                                    className={
                                                        ((this.state.dobError) ? "has-error" : "")
                                                    } />
                                                {this.state.dobError === "" ? "" : <label className="color-red d-block">{this.state.dobError}</label>}
                                                
                                            </div>    
                                        </div> 
                                    </div>
                                    

                                </div>

                                <div className="row"> 
                                    <div className="col-sm-12 confirmation-text">
                                        <Checkbox
                                        onChange={this.onChange}
                                        checked={this.state.isAck}
                                        className="d-flex"
                                        >
                                                    <div className="displayInGrid">
                                                        <Text k="submitForm.confirmDetailsCorrect" />
                                                    </div>
                                                    {/* Phase C.7.4D-R1 (§4): ent-required-asterisk — zero gap after label text (separate JSX lines, whitespace stripped). */}
                                                    <span className="color-red ent-required-asterisk">*</span>
                                                
                                        </Checkbox>
                                    </div>
                                </div>
                            </div>
                        </Card>
                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="form-action d-flex justify-content-center ">
                                    <ButtonComponent
                                        id="btnCancel"
                                        type="button"
                                        value={<div className='displayInGrid'><Text k="submitForm.cancelButton" /></div>}
                                        className="button-global button-border mr-4 autoHeight"
                                        onClick={this.onCancel}
                                    />
                                    <ButtonComponent
                                        id="btnPrevious"
                                        type="button"
                                        value={<div className='displayInGrid'><Text k="submitForm.previousButton" /></div>}
                                        className="button-global button-border mr-4 autoHeight"
                                        onClick={this.onPrevious}
                                    />
                                    <ButtonComponent
                                        id="btnSubmit"
                                        type="button"
                                        value={<div className='displayInGrid'><Text k="submitForm.submitButton" /></div>}
                                        className={!this.state.isAck ? "button-global button-border disabled autoHeight" : "button-global button-primary autoHeight"}
                                        disabled={!this.state.isAck}
                                        onClick={this.submitFormData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }

        if (this.props.IsExamPaymentOnline) {
            return (
                <>
                    <NavigationTab onTabOrderChange={this.onTabOrderChange} currentStep={4} />
                    {/* Stage 3.9 (Task 1): mt-4/mb-4 -> mt-3/mb-3 — density trim. */}
                    <div className="ch-make-payment ent-container gl-bxbr  analysisWrap p-4 mt-3">

                        <Text k="submitForm.onlineMakePaymentHeading" tag="h4" className="ch-heading4 mb-3" />
                        <Card>
                            <div className="container-fluid pr-0 pl-0 borderb">
                                <div className="row "> 
                                    <div className="col-sm-12"> 
                                        <div dangerouslySetInnerHTML={{ __html: localStorage['OnlinePaymentFormSubmitNote'] }}></div>
                                    </div>  
                                </div>
                                
                            </div>
                            <div className="container-fluid pt-3 pr-0 pl-0">
                                <div className="row"> 
                                    <div className="col-sm-12 confirmation-text">
                                        <Checkbox
                                        onChange={this.onChange}
                                        checked={this.state.isAck}
                                        className="d-flex"
                                        >
                                                    <div className="displayInGrid">
                                                        <Text k="submitForm.confirmDetailsCorrect" />
                                                    </div>
                                                    {/* Phase C.7.4D-R1 (§4): ent-required-asterisk — zero gap after label text (separate JSX lines, whitespace stripped). */}
                                                    <span className="color-red ent-required-asterisk">*</span>
                                                
                                        </Checkbox>
                                    </div>
                                </div>
                            </div>
                        </Card>
                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="form-action d-flex justify-content-end ">
                                    
                                    

                                    <ButtonComponent
                                        id="btnCancel"
                                        type="button"
                                        value={<div className='displayInGrid'><Text k="submitForm.cancelButton" /></div>}
                                        className="button-global button-border mr-4 autoHeight"
                                        onClick={this.onCancel} />

                                    <ButtonComponent
                                        id="btnPrevious"
                                        type="button"
                                        value={<div className='displayInGrid'><Text k="submitForm.previousButton" /></div>}
                                        className="button-global button-border mr-4 autoHeight"
                                        onClick={this.onPrevious} />

                                    <Payments
                                    isDisabled={this.state.loading || !this.state.isAck}
                                    onTabOrderChange={this.onTabOrderChange}
                                    onRedirectToHome={this.onRedirectToHome}></Payments>
                                </div>
                            </div>
                        </div>
                        {this.state.loading && <LoadingSpinner />}
                    </div>
                </>
            )
        }
    };
}

export default SubmitForm;